import { render } from "./BlogCoverPreview.vue?vue&type=template&id=4f7808b3&scoped=true"
import script from "./BlogCoverPreview.vue?vue&type=script&lang=js"
export * from "./BlogCoverPreview.vue?vue&type=script&lang=js"

import "./BlogCoverPreview.vue?vue&type=style&index=0&id=4f7808b3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7808b3"]])

export default __exports__